import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';

import { ReservationSummaryAgentDialogComponent } from './reservation-summary-agent-dialog/reservation-summary-agent-dialog.component';
import { ReservationService } from '../../reservation.service';
import { Reservation, Seller } from '../../reservation.model';

@Component({
	selector: 'app-reservation-summary-agent',
	templateUrl: './reservation-summary-agent.component.html',
	styleUrls: ['./reservation-summary-agent.component.scss'],
})
export class ReservationSummaryAgentComponent implements OnInit {
	displayedColumns = ['phone', 'email', 'city'];

	matData = new MatTableDataSource<any>();
	reservation: Reservation = null;

	seller: Seller = null;

	constructor(
		private readonly dialog: MatDialog,
		private readonly _service: ReservationService,
	) {
		this.matData.data = [
			{
				phone: '',
				email: '',
				city: '',
			},
		];
	}

	ngOnInit() {
		this._service.reservation$.subscribe((result) => {
			this.reservation = result;
			this.loadSeller();
		});
	}

	get editUrl() {
		return `/organization/${this.seller?.id}`;
	}

	openDialog() {
		const dialogRef = this.dialog
			.open(ReservationSummaryAgentDialogComponent, {
				minWidth: '550px',
				data: this.reservation.id,
			})
			.afterClosed()
			.subscribe(() => {
				dialogRef.unsubscribe();
			});
	}

	loadSeller() {
		this.seller = this.reservation?.seller;
		this.matData.data = [
			{
				phone: this.seller.departments[0]?.departmentContacts[0].phone,
				email: this.seller.departments[0]?.departmentContacts[0].email,
				city: this.seller.address[0]?.location.name,
			},
		];
	}

	goToSellerEdit() {
		window.open(this.editUrl, '_blank');
	}
}
